import React, {useState, useEffect} from 'react';
import useAsyncEffect from 'use-async-effect';
import {match, Link} from 'react-router-dom';
import {connect} from 'react-redux';
import {AnyAction} from 'redux';
import {ThunkDispatch} from 'redux-thunk';

import {AppState} from '../Store';
import {loadExceptionsCreator} from '../Store/Admin/Actions';
import {ExceptionService, Exception} from '../Services/ExceptionService';
import {Page} from '../Models';

import LoadMore from '../Components/LoadMore';
import ExceptionPanel from './ExceptionPanel';

type TParams = {
  id?: string
}

interface ErrorsProps {
  match: match<TParams>;

  exceptionService: ExceptionService;
  exceptions: Page<Exception>;

  setPage: (page: number) => Promise<void>;
}

function Errors({match, exceptionService, exceptions, setPage}: ErrorsProps) {
  const [exception, setException] = useState<Exception | undefined>(undefined);

  useAsyncEffect(async isMounted => {
    const {params: {id}} = match;
    if (exception === undefined && id !== undefined) {
      try {
        const res = await exceptionService.byId(Number(id));
        if (res.parsedBody !== undefined && isMounted()) {
          setException(res.parsedBody);
        }
      } catch (e) {
        console.log(e);
      }
    }
  },[match]);

  useEffect(() => {
    if (exceptions.page === 1 && exceptions.items.length === 0) {
      setPage(1);
    }
  }, [exceptions, setPage]);

  const back = () => {
    setException(undefined);
  };

  const {page, pageCount} = exceptions;

  if (exception !== undefined) {
    return (
      <div>
        <div className="post-content-area mb-100">
          <div className="world-category-area">
            <ul className="nav nav-tabs" role="tablist">
              <li className="title"><Link to="/admin/errors" onClick={back}>Back</Link></li>
            </ul>
          </div>
        </div>
        <ExceptionPanel exception={exception} showInner />
      </div>
    );
  }

  const exceptionList = exceptions.items.map(exc => (
    <ExceptionPanel key={exc.id} exception={exc} showInner={false} />
  ));

  return (
    <div>
      <div className="page-container">
        <div className="pages">
          <LoadMore digits={2} currentPage={page} pages={pageCount} callback={setPage} fragment="/admin/surveys/" />
        </div>
      </div>
      {exceptionList}
      <div className="page-container">
        <div className="pages">
          <LoadMore digits={2} currentPage={page} pages={pageCount} callback={setPage} fragment="/admin/surveys/" />
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state: AppState) => {
  return {
    exceptionService: state.auth.exceptionService,
    exceptions: state.admin.exceptions.list,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    setPage: (page: number) => dispatch(loadExceptionsCreator(page)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Errors);
